import muistyled from "@emotion/styled";
import { Grid } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import { PopUp } from "../../animations/animations";

export const FooterContainer = muistyled(
  Grid,
  {}
)({
  display: "flex",
  height: "75px",
  backgroundColor: "#1E2022",
  justifyContent: "space-around",
  alignItems: "center",
});

export const IconWrapper = muistyled(
  Grid,
  {}
)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
});
export const IconsContainer = muistyled(
  Grid,
  {}
)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
});
export const CustomLinkedInIcon = muistyled(
  LinkedInIcon,
  {}
)({
  width: "50px",
  height: "50px",
  color: "#fff",
  ":hover": {
    animation: `${PopUp} 1s both`,
  },
});
export const LogoImgFooter = muistyled(
  "img",
  {}
)({
  width: "55px",
  height: "60px",
  marginTop: "5px",
});

export const CustomGitHubIcon = muistyled(
  GitHubIcon,
  {}
)({
  width: "50px",
  height: "50px",
  color: "#fff",

  ":hover": {
    animation: `${PopUp} 1s both`,
  },
});

export const IconLink = muistyled(
  "a",
  {}
)({
  width: "50px",
  height: "50px",
});
export const LogoContainer = muistyled(
  Grid,
  {}
)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
});
export const LogoWrap = muistyled(
  Grid,
  {}
)({
  display: "flex",
  width: "auto",
  justifyContent: "center",
  alignItems: "center",
});

export const CopyrightWrap = muistyled(Grid, {
  name: "CopyrightContainer",
})({
  display: "flex",
  width: "auto",
  justifyContent: "center",
  alignItems: "center",
});
